module.exports = __webpack_public_path__ + "img/logo-famille-boutrais-gris-footer.e99bc9da.png";